<template>
  <div
    v-if="svg"
    class="col-7 b-svg-container"
    @mousedown="mouseDown"
    @mousemove="mouseMove"
    @mouseup="mouseUp"
    @mouseleave="mouseUp"
    @keydown="trackAltDown"
    @keyup="trackAltUp"
    @wheel.prevent="wheelScale"
  >
    <div class="b-relative">
      <root>
        <div
          v-if="svg"
          v-html="svgParser"
        />
        <div
          class="b-scale-control"
          v-if="svg"
        >
          <div @click="scalePlus">
            +
          </div>
          <div @click="scaleMinus">
            -
          </div>
        </div>
      </root>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReportMaps",
  props: {
    svg: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isAltDown: false,
      isMouseDown: false,
      currentScale: 1,
      pos: {
        top: 0,
        left: 0,
        x: 0,
        y: 0,
      },
    };
  },
  mounted() {
    addEventListener('keydown', this.trackAltDown);
    addEventListener('keyup', this.trackAltUp);
  },
  computed: {
    svgElement() {
      return document.querySelector('svg');
    },
    svgParser() {
      if (!this.svg.length) {
        return null;
      }
      return (new DOMParser())
        .parseFromString(this.svg, 'image/svg+xml')
        .documentElement
        .outerHTML;
    },
  },
  methods: {
    mouseDown(e) {
      this.isMouseDown = true;
      e.currentTarget.style.cursor = 'grabbing';
      this.pos = {
        top: e.currentTarget.scrollTop,
        left: e.currentTarget.scrollLeft,
        x: e.clientX,
        y: e.clientY,
      };
    },
    mouseMove(e) {
      if (this.isMouseDown) {
        e.currentTarget.scrollTop = this.pos.top - (e.clientY - this.pos.y);
        e.currentTarget.scrollLeft = this.pos.left - (e.clientX - this.pos.x);
      }
    },
    mouseUp(e) {
      this.isMouseDown = false;
      e.currentTarget.style.cursor = 'grab';
    },
    scalePlus() {
      this.currentScale += 0.05;
      this.svgElement.style.scale = `${this.currentScale}`;
    },
    scaleMinus() {
      this.currentScale -= 0.05;
      this.svgElement.style.scale = `${this.currentScale}`;
    },
    wheelScale(e) {
      if (this.isAltDown) {
        if (e.deltaY > 0) {
          this.scaleMinus()
        }
        if (e.deltaY < 0) {
          this.scalePlus()
        }
      }
    },
    trackAltDown(e) {
      if (e.keyCode === 18) {
        e.preventDefault();
        this.isAltDown = true;
      }
    },
    trackAltUp() {
      this.isAltDown = false;
    },
  },
}

</script>

<style scoped>
.b-svg-container {
  top: 28px;
  position: sticky;
  cursor: grab;
  margin: 15px 0 0 0;
  background-color: white;
  border-radius: 3px;
  border: solid 1px #e5e5e5;
  overflow: auto;
  height: 90.5vh;
  user-select: none;
}

.b-svg-container svg {
  width: 100%;
  height: 100%;
}

.b-relative {
  position: relative;
}

.b-scale-control {
  position: fixed;
  bottom: 10%;
  z-index: 100;
  display: grid;
  grid-template-columns: 1fr;
  border: solid 1px black;
  width: 32px;
  background-color: white;
  justify-items: center;
  align-items: center;
}

.b-scale-control div {
  display: grid;
  justify-content: center;
  align-content: baseline;
  width: 32px;
  height: 32px;
  line-height: 26px;
  font-weight: bold;
  font-size: 24px;
  cursor: pointer;
}

.b-scale-control div:nth-child(1) {
  border-bottom: solid 1px black;
}
</style>
